import { Box, Grid, Typography } from "@mui/material";
import VTBSearchFilter from "./VTBSearchFilter";
import { useAppSelector } from "../../store/hooks";

const VTBFilters = () => {
  const vTBSearchDetails = useAppSelector((state) => state.ncgDetails?.result);

  return (
    <Grid
      sx={{
        width: "100%",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          paddingBlock: 1,
          //   display: { xs: "none", sm: "none", md: "inherit" },
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          <Box
            sx={{
              display: {
                xs: "none",
                lg: "flex",
              },
              gap: 1,
            }}
          >
            <Typography
              fontWeight={"700"}
              fontSize={"20px"}
              lineHeight={"24px"}
            >
              Results
            </Typography>

            <Typography
              fontWeight={"700"}
              fontSize={"20px"}
              lineHeight={"24px"}
            >
              {vTBSearchDetails?.hits?.toLocaleString("en-US")}
            </Typography>
          </Box>
        </Box>
      </Box>

      <VTBSearchFilter jsonFacets={vTBSearchDetails?.jsonfacets} />
    </Grid>
  );
};

export default VTBFilters;
